// src/App.js
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import { CartContext } from "./CartContext";
import CheckoutPage from "./pages/CheckoutPage";
import BankTransferPage from "./pages/BankTransferPage";

export default function App() {
  const [lang, setLang] = useState("pl");
  const [cart, setCart] = useState([]);

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const clearCart = () => setCart([]);

  return (
    <BrowserRouter>
      <CartContext.Provider
        value={{ cart, addToCart, removeFromCart, clearCart }}
      >
        <Routes>
          {/* Layout opakowuje stronę główną */}
          <Route
            path="/*"
            element={<Layout lang={lang} setLang={setLang} />}
          />

          {/* CHECKOUT */}
          <Route
            path="/checkout"
            element={<CheckoutPage lang={lang} />}
          />
        </Routes>
      </CartContext.Provider>
    </BrowserRouter>
  );
}
